import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey5 } from 'approot/shared/styles/colours.style';
import {
  PStyled,
  font18,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import { InteractiveDragContainer } from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag.style';

export const InteractiveResponseTabs = styled.div`
  border-bottom: 1px solid ${grey5};
  height: ${rem(64)};
  flex-shrink: 0;
`;

export const InteractiveResponseQuestionSequenceText = styled(PStyled)`
  ${font18}
  font-weight: ${fontWeightMedium};
  margin-bottom: 0;
`;

export const InteractiveResponseQuestionSequenceItem = styled.div`
  width: ${rem(54)};
  height: ${rem(54)};
  ${InteractiveDragContainer} {
    transform-origin: left top;
  }
`;
